import axios from "axios";
import Repository from "@/api/repository";
const resource = "user/v1";
export default {
    getUser(userId) {
        return Repository.get(`${resource}/edit/${userId}`);
    },
    getUserIsHardwareLicenseAdmin() {
        const customAxios = axios.create({ baseURL: '/' });
        return customAxios.get('user/IsHardwareLicenseAdmin');
    }
};
